export const WEBSITE_ASTRO_T9_ITEMS = [
  {
    "stt": 1,
    "time": "2026-09-01 11:23",
    "name": "Điều khoản dịch vụ",
    "cat": "Page (Doanh nghiệp & Dịch vụ)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/dieu-khoan-dich-vu",
    "desc": "Thiết kế mới 100% bằng code Astro thay thế văn bản cũ phong cách pháp lý cao cấp"
  },
  {
    "stt": 2,
    "time": "2026-09-03 21:12",
    "name": "Hướng dẫn đánh giá FIT TOUR trên Google Maps",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/huong-dan-danh-gia-fit-tour",
    "desc": "Hướng dẫn khách hàng review Google Maps từng bước bằng Native Astro"
  },
  {
    "stt": 3,
    "time": "2026-09-04 16:48",
    "name": "Du lịch Hoàng Sơn Trung Quốc: Kinh nghiệm từ A-Z",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/nui-hoang-son",
    "desc": "Cẩm nang Hoàng Sơn (UNESCO), biển mây, tuyết, cáp treo, vé 2026"
  },
  {
    "stt": 4,
    "time": "2026-09-04 19:18",
    "name": "Làng cổ Hoành Thôn Trung Quốc",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/lang-co-hoanh-thon",
    "desc": "Khám phá Làng cổ Hoành Thôn (Hongcun) gần 900 năm tuổi"
  },
  {
    "stt": 5,
    "time": "2026-09-04 20:49",
    "name": "Phố bar Sanlitun Bắc Kinh",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/pho-bar-sanlitun",
    "desc": "Cẩm nang trải nghiệm đêm Bắc Kinh & phố bar Sanlitun"
  },
  {
    "stt": 6,
    "time": "2026-09-04 21:58",
    "name": "Tứ đại cố đô Trung Quốc",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/tu-dai-co-do-trung-quoc",
    "desc": "Nghiên cứu Tứ đại cố đô: Tây An, Lạc Dương, Nam Kinh, Bắc Kinh"
  },
  {
    "stt": 7,
    "time": "2026-09-05 07:20",
    "name": "Ngọc Môn Quan - Dấu tích cửa ải Con đường Tơ lụa",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/ngoc-mon-quan",
    "desc": "Dấu tích cửa ải ngọc bích trên Con đường Tơ Lụa"
  },
  {
    "stt": 8,
    "time": "2026-09-05 08:20",
    "name": "Du lịch Đôn Hoàng - Hành trình qua di sản Con đường Tơ lụa",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/don-hoang",
    "desc": "Di sản Đôn Hoàng & Hang đá Mạc Cao"
  },
  {
    "stt": 9,
    "time": "2026-09-05 09:39",
    "name": "Hồ Thanh Hải - Hồ nước mặn lớn nhất Trung Quốc",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/ho-thanh-hai",
    "desc": "Khám phá hồ nước mặn lớn nhất Trung Quốc"
  },
  {
    "stt": 10,
    "time": "2026-09-05 11:34",
    "name": "Tour Lệ Giang - Shangri-La 6N5Đ",
    "cat": "Tour",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/tour/tour-le-giang-6n5d",
    "desc": "Chuẩn hóa Benchmark Lệ Giang toàn diện (Icon SVG, Sticky Card, ERP Schedule)"
  },
  {
    "stt": 11,
    "time": "2026-09-05 11:34",
    "name": "Tour Tân Cương Mùa Thu 8N7Đ",
    "cat": "Tour",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/tour/tour-tan-cuong-mua-thu",
    "desc": "Nâng cấp ERP Schedule & FAQ Accordion"
  },
  {
    "stt": 12,
    "time": "2026-09-05 11:34",
    "name": "Tour Đạo Thành Á Đinh Expedition 9N8Đ",
    "cat": "Tour",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/tour/tour-dao-thanh-a-dinh-expedition",
    "desc": "Cập nhật lịch trình và bảng giá B2C"
  },
  {
    "stt": 13,
    "time": "2026-09-05 11:34",
    "name": "Tour Thanh Hải - Cam Túc 8N7Đ",
    "cat": "Tour",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/tour/tour-thanh-hai-cam-tuc",
    "desc": "Đồng bộ liên kết chéo cụm Con Đường Tơ Lụa"
  },
  {
    "stt": 14,
    "time": "2026-09-05 11:34",
    "name": "Tour Mông Cổ 8N7Đ",
    "cat": "Tour",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/tour/tour-mong-co-8n7d",
    "desc": "Tối ưu hóa bảng giá ERP và Mobile Bottom Bar"
  },
  {
    "stt": 15,
    "time": "2026-09-05 11:34",
    "name": "Tour Hành Hương Núi Kailash 12N11Đ",
    "cat": "Tour",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/tour/tour-hanh-huong-nui-kailash-12n11d",
    "desc": "Tối ưu Product Schema & Breadcrumbs"
  },
  {
    "stt": 16,
    "time": "2026-09-05 11:34",
    "name": "Tour Bhutan 5N4Đ",
    "cat": "Tour",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/tour/tour-bhutan-5n4d",
    "desc": "Tích hợp bảng lịch trình 2 đầu bay TPHCM và Hà Nội"
  },
  {
    "stt": 17,
    "time": "2026-09-05 11:34",
    "name": "Tour Sri Lanka 8N8Đ",
    "cat": "Tour",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/tour/tour-sri-lanka",
    "desc": "Nâng cấp bảng giá và chuẩn hóa font size"
  },
  {
    "stt": 18,
    "time": "2026-09-05 11:34",
    "name": "Tour Maroc 12N11Đ",
    "cat": "Tour",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/tour/tour-maroc-12n11d",
    "desc": "Nâng cấp bộ nhận diện và CTA"
  },
  {
    "stt": 19,
    "time": "2026-09-05 11:34",
    "name": "Tour Trương Gia Giới - Phượng Hoàng Cổ Trấn 6N5Đ",
    "cat": "Tour",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/tour/tour-truong-gia-gioi-phuong-hoang-co-tran-6n5d",
    "desc": "Tối ưu typography và Mobile Sticky CTA"
  },
  {
    "stt": 20,
    "time": "2026-09-05 11:34",
    "name": "Tour Bắc Kinh Khởi Hành Từ Hà Nội 5N4Đ",
    "cat": "Tour",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/tour/tour-bac-kinh-tu-ha-noi",
    "desc": "Cập nhật breadcrumbs và header"
  },
  {
    "stt": 21,
    "time": "2026-09-05 14:58",
    "name": "Kinh nghiệm du lịch Cam Túc",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/du-lich-cam-tuc",
    "desc": "Cẩm nang tỉnh Cam Túc chuyên sâu"
  },
  {
    "stt": 22,
    "time": "2026-09-05 17:02",
    "name": "Kinh nghiệm du lịch Thanh Hải Trung Quốc",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/kinh-nghiem-du-lich-thanh-hai",
    "desc": "Kinh nghiệm mùa đi, hoa cải và lộ trình Thanh Hải"
  },
  {
    "stt": 23,
    "time": "2026-09-05 18:17",
    "name": "Nguyệt Nha Tuyền - Ốc đảo trăng khuyết sa mạc",
    "cat": "Post (Cẩm nang)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/nguyet-nha-tuyen",
    "desc": "Chuyển đổi ốc đảo trăng khuyết sang layout Editorial 3 cột"
  },
  {
    "stt": 24,
    "time": "2026-09-05 19:14",
    "name": "Tour Cáp Nhĩ Tân 7N6Đ",
    "cat": "Tour",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-cap-nhi-tan",
    "desc": "Xây dựng trang Native Astro Tour Cáp Nhĩ Tân 7N6Đ chuẩn SOP Lệ Giang"
  },
  {
    "stt": 25,
    "time": "2026-09-05 19:34",
    "name": "Tour Cáp Nhĩ Tân 7N6Đ Mùa Đông",
    "cat": "Tour",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-cap-nhi-tan-7n6d",
    "desc": "Route biến thể chuẩn SEO cho mùa đông"
  },
  {
    "stt": 26,
    "time": "2026-09-05 20:46",
    "name": "Lễ hội điêu khắc băng Cáp Nhĩ Tân",
    "cat": "Post (Cẩm nang)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/le-hoi-dieu-khac-bang-cap-nhi-tan",
    "desc": "Viết lại code Astro Native cho Lễ hội băng đăng"
  },
  {
    "stt": 27,
    "time": "2026-09-05 21:37",
    "name": "Nhà thờ Saint Sophia Cáp Nhĩ Tân",
    "cat": "Post (Cẩm nang)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/nha-tho-saint-sophia-cap-nhi-tan",
    "desc": "Chuyển đổi Nhà thờ Saint Sophia sang layout 3 cột chuẩn mực"
  },
  {
    "stt": 28,
    "time": "2026-09-05 21:57",
    "name": "Làng tuyết Cáp Nhĩ Tân",
    "cat": "Post (Cẩm nang)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/lang-tuyet-cap-nhi-tan",
    "desc": "Tái lập trình trang Làng tuyết Cáp Nhĩ Tân sang Astro"
  },
  {
    "stt": 29,
    "time": "2026-09-05 22:40",
    "name": "Tour Du Lịch Ai Cập 9N8Đ",
    "cat": "Tour",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/tour/tour-du-lich-ai-cap",
    "desc": "Nâng cấp bảng giá ERP live data"
  },
  {
    "stt": 30,
    "time": "2026-09-05 22:40",
    "name": "Tour Đài Loan 5N4Đ",
    "cat": "Tour",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/tour/tour-dai-loan",
    "desc": "Cập nhật lịch khởi hành 2026"
  },
  {
    "stt": 31,
    "time": "2026-09-05 22:40",
    "name": "Tour Hàn Quốc 5N4Đ",
    "cat": "Tour",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/tour/tour-han-quoc-5n4d",
    "desc": "Đồng bộ hóa TourItinerary và FAQ"
  },
  {
    "stt": 32,
    "time": "2026-09-05 22:40",
    "name": "Tour Nhật Bản 6N5Đ",
    "cat": "Tour",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/tour/tour-nhat-ban-6n5d",
    "desc": "Nâng cấp form đăng ký tour B2C"
  },
  {
    "stt": 33,
    "time": "2026-09-06 05:46",
    "name": "Thời gian tốt nhất du lịch Cáp Nhĩ Tân",
    "cat": "Post (Cẩm nang)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/thoi-gian-tot-nhat-du-lich-cap-nhi-tan",
    "desc": "Viết mới code Astro cho bài phân tích mùa đi Cáp Nhĩ Tân"
  },
  {
    "stt": 34,
    "time": "2026-09-06 08:12",
    "name": "Hoạt động phải làm ở Cáp Nhĩ Tân",
    "cat": "Post (Cẩm nang)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/hoat-dong-phai-lam-o-cap-nhi-tan",
    "desc": "Chuyển đổi Top hoạt động Cáp Nhĩ Tân sang Astro"
  },
  {
    "stt": 35,
    "time": "2026-09-06 09:41",
    "name": "Chinh phục rừng tuyết Song Phong Cáp Nhĩ Tân",
    "cat": "Post (Cẩm nang)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/chinh-phuc-rung-tuyet-song-phong-cap-nhi-tan",
    "desc": "Viết mới code Astro cho cung trekking rừng tuyết"
  },
  {
    "stt": 36,
    "time": "2026-09-06 12:13",
    "name": "Cáp Nhĩ Tân nên đi tự túc hay theo tour?",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/cap-nhi-tan-nen-di-tu-tuc-hay-theo-tour",
    "desc": "Bài phân tích so sánh chi tiết tự túc vs đi tour"
  },
  {
    "stt": 37,
    "time": "2026-09-06 15:38",
    "name": "Phố đi bộ Bùi Viện",
    "cat": "Post (Cẩm nang)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/pho-di-bo-bui-vien",
    "desc": "Xây dựng lại layout Astro Native cho bài Phố đi bộ Bùi Viện"
  },
  {
    "stt": 38,
    "time": "2026-09-06 20:05",
    "name": "Hồ Thiên Trì Trường Bạch Sơn",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/ho-thien-tri-truong-bach-son",
    "desc": "Hồ Thiên Trì trên đỉnh núi lửa Trường Bạch Sơn"
  },
  {
    "stt": 39,
    "time": "2026-09-07 09:18",
    "name": "Hắt nước sôi thành tuyết ở Làng Tuyết",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/hat-nuoc-soi-thanh-tuyet",
    "desc": "Hiện tượng hắt nước sôi thành tuyết ở Làng Tuyết"
  },
  {
    "stt": 40,
    "time": "2026-09-07 10:18",
    "name": "Đi Cáp Nhĩ Tân mùa đông mặc gì?",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/di-cap-nhi-tan-mac-gi",
    "desc": "Checklist trang phục chống rét -20°C đến -30°C"
  },
  {
    "stt": 41,
    "time": "2026-09-07 20:47",
    "name": "Quy chuẩn thương hiệu Elite Incentive & MICE",
    "cat": "Page (Doanh nghiệp & Dịch vụ)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/elite-brand-guidelines",
    "desc": "Bộ nhận diện thương hiệu & Logo Elite Incentive & MICE"
  },
  {
    "stt": 42,
    "time": "2026-09-07 22:54",
    "name": "Tour 3 Nước Trung Á (3Stan) 13N11Đ",
    "cat": "Tour",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-3stan",
    "desc": "Xây dựng trang Native Astro cho Tour 3 Nước Trung Á (13N11D)"
  },
  {
    "stt": 43,
    "time": "2026-09-08 10:08",
    "name": "Tour Doanh Nghiệp FIT Tour",
    "cat": "Page (Doanh nghiệp & Dịch vụ)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/tour-doanh-nghiep",
    "desc": "Re-architecture toàn bộ Hub Tour Doanh Nghiệp sang Native Astro"
  },
  {
    "stt": 44,
    "time": "2026-09-08 10:10",
    "name": "Tour Incentive Travel Doanh Nghiệp",
    "cat": "Page (Doanh nghiệp & Dịch vụ)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/tour-incentive-travel-doanh-nghiep",
    "desc": "Nâng cấp trang Incentive Travel B2B theo mẫu chuẩn Benchmark"
  },
  {
    "stt": 45,
    "time": "2026-09-08 10:10",
    "name": "Company Trip Doanh Nghiệp",
    "cat": "Page (Doanh nghiệp & Dịch vụ)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/company-trip",
    "desc": "Đồng bộ giao diện thẻ dịch vụ, hero banner và form liên hệ B2B"
  },
  {
    "stt": 46,
    "time": "2026-09-08 10:10",
    "name": "Corporate Retreat Doanh Nghiệp",
    "cat": "Page (Doanh nghiệp & Dịch vụ)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/corporate-retreat",
    "desc": "Thiết kế lại toàn bộ luồng nội dung nghỉ dưỡng cao cấp doanh nghiệp"
  },
  {
    "stt": 47,
    "time": "2026-09-08 10:10",
    "name": "Tổ chức sự kiện công ty cho doanh nghiệp (MICE)",
    "cat": "Page (Doanh nghiệp & Dịch vụ)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/to-chuc-su-kien-cong-ty-cho-doanh-nghiep",
    "desc": "Nâng cấp giao diện MICE Event và quy chuẩn thẻ Card"
  },
  {
    "stt": 48,
    "time": "2026-09-08 16:45",
    "name": "Giới thiệu FIT TOUR",
    "cat": "Page (Doanh nghiệp & Dịch vụ)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/gioi-thieu",
    "desc": "Cập nhật cấu trúc trang Giới thiệu công ty FIT TOUR"
  },
  {
    "stt": 49,
    "time": "2026-09-08 16:45",
    "name": "Địa điểm tổ chức sự kiện Nha Trang",
    "cat": "Page (Doanh nghiệp & Dịch vụ)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/dia-diem-to-chuc-nha-trang",
    "desc": "Tối ưu layout địa điểm tổ chức sự kiện Nha Trang"
  },
  {
    "stt": 50,
    "time": "2026-09-09 08:26",
    "name": "Tour Công Ty FIT Tour",
    "cat": "Page (Doanh nghiệp & Dịch vụ)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/tour-cong-ty",
    "desc": "Trang Archive trung tâm cho phân khúc Tour Doanh Nghiệp"
  },
  {
    "stt": 51,
    "time": "2026-09-09 14:55",
    "name": "KienlongBank Bình Dương Company Trip Phan Thiết",
    "cat": "Post (Case Study)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/kienlongbank-binh-duong-company-trip-phan-thiet",
    "desc": "Case study Company Trip KienlongBank Bình Dương tại Phan Thiết"
  },
  {
    "stt": 52,
    "time": "2026-09-10 20:52",
    "name": "Hành trình Hàn Quốc cùng VIB - Private Tour",
    "cat": "Post (Case Study)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/hanh-trinh-han-quoc-cung-vib-private-tour",
    "desc": "Case study Private Tour Seoul & Nami cho ngân hàng VIB"
  },
  {
    "stt": 53,
    "time": "2026-09-10 21:20",
    "name": "Việt Hồng Private Tour Trùng Khánh",
    "cat": "Post (Case Study)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/viet-hong-private-tour-trung-khanh",
    "desc": "Tái thiết kế toàn diện trang Private Tour công ty Việt Hồng"
  },
  {
    "stt": 54,
    "time": "2026-09-11 09:25",
    "name": "Hình ảnh Ladakh - Showroom Ảnh",
    "cat": "Gallery Showroom",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/gallery-ladakh",
    "desc": "Nâng cấp lưới ảnh Masonry, sửa link ảnh hỏng, đồng bộ BaseLayout"
  },
  {
    "stt": 55,
    "time": "2026-09-11 09:25",
    "name": "Hình ảnh Alaska - Showroom Ảnh",
    "cat": "Gallery Showroom",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/hinh-anh-alaska",
    "desc": "Chuẩn hóa card 16:9 và cấu hình GLightbox zoom"
  },
  {
    "stt": 56,
    "time": "2026-09-12 14:28",
    "name": "FIT Tour tổ chức Motor Adventure cho Honda Vietnam",
    "cat": "Post (E-Magazine)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/fit-tour-to-chuc-motor-adventure-cho-honda-vietnam",
    "desc": "E-Magazine hành trình thực địa Honda Vietnam tại Ladakh"
  },
  {
    "stt": 57,
    "time": "2026-09-12 14:56",
    "name": "Đằng sau hành trình 14 Riders chinh phục Umling La",
    "cat": "Post (Case Study)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/dang-sau-14-riders-chinh-phuc-umlingla",
    "desc": "Case study hậu trường điều phối logistics đèo cao nhất thế giới"
  },
  {
    "stt": 58,
    "time": "2026-09-12 15:42",
    "name": "Honda Vietnam & Friends ở Himalaya",
    "cat": "Post (E-Magazine)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/honda-vietnam-and-friends-o-himalaya",
    "desc": "E-Magazine hình ảnh cộng đồng Riders chinh phục Himalaya"
  },
  {
    "stt": 59,
    "time": "2026-09-12 16:03",
    "name": "Cung đường Motor Ladakh: Pangong – Hanle – Umlingla",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/cung-duong-motor-ladakh-pangong-hanle-umlingla",
    "desc": "Trinh sát địa hình cung đường Pangong – Hanle – Umling La"
  },
  {
    "stt": 60,
    "time": "2026-09-12 17:12",
    "name": "Motor Adventure Là Gì? Cách FIT TOUR Tạo Khác Biệt",
    "cat": "Post (E-Magazine)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/motor-adventure-la-gi",
    "desc": "Pillar Guide cốt lõi tích hợp 61 ảnh thực địa độc quyền"
  },
  {
    "stt": 61,
    "time": "2026-09-12 17:38",
    "name": "Road Captain Là Gì? Vai Trò Trong Motor Adventure",
    "cat": "Post (E-Magazine)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/road-captain",
    "desc": "Chuyên đề vai trò Road Captain với 18 ảnh thực địa"
  },
  {
    "stt": 62,
    "time": "2026-09-12 18:07",
    "name": "Riding Formation Là Gì? Vì Sao Đội Hình Quan Trọng?",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/riding-formation",
    "desc": "Cẩm nang đội hình di chuyển an toàn khi đi motor adventure"
  },
  {
    "stt": 63,
    "time": "2026-09-12 18:19",
    "name": "Vì Sao Ladakh Là Điểm Đến Đặc Biệt Với Motor Adventure?",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/vi-sao-ladakh-la-diem-den-dac-biet-voi-motor-adventure",
    "desc": "Giá trị văn hóa, địa hình độc bản của Ladakh"
  },
  {
    "stt": 64,
    "time": "2026-09-13 14:59",
    "name": "Kinh nghiệm du lịch Cáp Nhĩ Tân từ A-Z",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/kinh-nghiem-du-lich-cap-nhi-tan",
    "desc": "Cẩm nang tổng lực Cáp Nhĩ Tân từ A-Z"
  },
  {
    "stt": 65,
    "time": "2026-09-14 10:54",
    "name": "Tứ hợp viện là gì? Kiến trúc truyền thống 3.000 năm",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/tu-hop-vien",
    "desc": "Kiến trúc Tứ hợp viện cổ kính Trung Hoa"
  },
  {
    "stt": 66,
    "time": "2026-09-14 13:07",
    "name": "Du lịch Hắc Long Giang Trung Quốc",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/du-lich-hac-long-giang",
    "desc": "Cẩm nang du lịch toàn cảnh tỉnh Hắc Long Giang"
  },
  {
    "stt": 67,
    "time": "2026-09-15 10:04",
    "name": "Hình ảnh đoàn Honda Vietnam tại Himalaya Ladakh",
    "cat": "Gallery Showroom",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/hinh-anh-doan-honda-vietnam-tai-himalaya-ladakh",
    "desc": "Bộ ảnh thực địa đoàn Honda Vietnam tại Himalaya Ladakh (30 ảnh)"
  },
  {
    "stt": 68,
    "time": "2026-09-15 14:21",
    "name": "Hình ảnh Motor Adventure Ladakh",
    "cat": "Gallery Showroom",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/gallery-motor-adventure-ladakh",
    "desc": "Phòng trưng bày ảnh Motor Adventure Ladakh (45 ảnh)"
  },
  {
    "stt": 69,
    "time": "2026-09-15 16:41",
    "name": "Hình ảnh Everest Base Camp",
    "cat": "Gallery Showroom",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/gallery-everest-base-camp",
    "desc": "Phòng trưng bày ảnh Everest Base Camp (57 ảnh)"
  },
  {
    "stt": 70,
    "time": "2026-09-16 06:44",
    "name": "Hình ảnh Bhutan",
    "cat": "Gallery Showroom",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/gallery-bhutan",
    "desc": "Phòng trưng bày ảnh Vương quốc Hạnh phúc Bhutan (37 ảnh)"
  },
  {
    "stt": 71,
    "time": "2026-09-16 06:59",
    "name": "Hình ảnh Tây Tạng",
    "cat": "Gallery Showroom",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/gallery-tay-tang",
    "desc": "Phòng trưng bày ảnh Vùng đất Tây Tạng huyền bí (17 ảnh)"
  },
  {
    "stt": 72,
    "time": "2026-09-16 07:22",
    "name": "Hình ảnh Nam Cương Tân Cương",
    "cat": "Gallery Showroom",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/hinh-anh-nam-cuong",
    "desc": "Phòng trưng bày ảnh Sa mạc Nam Cương Tân Cương (24 ảnh)"
  },
  {
    "stt": 73,
    "time": "2026-09-16 07:59",
    "name": "Hình ảnh Mông Cổ",
    "cat": "Gallery Showroom",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/hinh-anh-mong-co",
    "desc": "Phòng trưng bày ảnh Thảo nguyên Mông Cổ (32 ảnh)"
  },
  {
    "stt": 74,
    "time": "2026-09-16 08:16",
    "name": "Hình ảnh Kim Tự Tháp Ai Cập",
    "cat": "Gallery Showroom",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/hinh-anh-kim-tu-thap",
    "desc": "Phòng trưng bày ảnh Kỳ quan Kim Tự Tháp Ai Cập (20 ảnh)"
  },
  {
    "stt": 75,
    "time": "2026-09-16 08:28",
    "name": "Hình ảnh Pakistan",
    "cat": "Gallery Showroom",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/gallery-pakistan",
    "desc": "Phòng trưng bày ảnh Pakistan Karakoram (28 ảnh)"
  },
  {
    "stt": 76,
    "time": "2026-09-16 08:37",
    "name": "Hình ảnh Ai Cập",
    "cat": "Gallery Showroom",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/gallery-ai-cap",
    "desc": "Phòng trưng bày ảnh Ai Cập cổ đại & Sông Nile (30 ảnh)"
  },
  {
    "stt": 77,
    "time": "2026-09-16 08:52",
    "name": "Hình ảnh Mùa thu Giang Nam",
    "cat": "Gallery Showroom",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/hinh-anh-mua-thu-giang-nam",
    "desc": "Phòng trưng bày ảnh Mùa thu Giang Nam thủy trấn (25 ảnh)"
  },
  {
    "stt": 78,
    "time": "2026-09-16 09:07",
    "name": "Hình ảnh Đạo Thành Á Đinh",
    "cat": "Gallery Showroom",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/hinh-anh-dao-thanh-a-dinh",
    "desc": "Phòng trưng bày ảnh Đạo Thành Á Đinh (21 ảnh)"
  },
  {
    "stt": 79,
    "time": "2026-09-16 09:28",
    "name": "Hình ảnh Vụ Nữ Châu",
    "cat": "Gallery Showroom",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/hinh-anh-vu-nu-chau",
    "desc": "Phòng trưng bày ảnh Vụ Nữ Châu Giang Tây (18 ảnh)"
  },
  {
    "stt": 80,
    "time": "2026-09-16 09:35",
    "name": "Hình ảnh Vọng Tiên Cốc",
    "cat": "Gallery Showroom",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/hinh-anh-vong-tien-coc",
    "desc": "Phòng trưng bày ảnh Tiên cảnh Vọng Tiên Cốc (22 ảnh)"
  },
  {
    "stt": 81,
    "time": "2026-09-16 10:28",
    "name": "Hình ảnh Cát Tiên Thôn",
    "cat": "Gallery Showroom",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/hinh-anh-cat-tien-thon",
    "desc": "Phòng trưng bày ảnh Cát Tiên Thôn (20 ảnh)"
  },
  {
    "stt": 82,
    "time": "2026-09-16 10:44",
    "name": "Hình ảnh Thổ Lâu Phúc Kiến",
    "cat": "Gallery Showroom",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/hinh-anh-tho-lau-phuc-kien",
    "desc": "Phòng trưng bày ảnh Thổ Lâu Phúc Kiến (19 ảnh)"
  },
  {
    "stt": 83,
    "time": "2026-09-16 11:09",
    "name": "Hình ảnh Ô Trấn",
    "cat": "Gallery Showroom",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/hinh-anh-o-tran",
    "desc": "Phòng trưng bày ảnh Ô Trấn cổ trấn (18 ảnh)"
  },
  {
    "stt": 84,
    "time": "2026-09-16 11:35",
    "name": "Hình ảnh Phim trường Hoành Điếm",
    "cat": "Gallery Showroom",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/hinh-anh-phim-truong-hoanh-diem",
    "desc": "Phòng trưng bày ảnh Phim trường Hoành Điếm (24 ảnh)"
  },
  {
    "stt": 85,
    "time": "2026-09-16 11:57",
    "name": "Hình ảnh Cửu Trại Câu",
    "cat": "Gallery Showroom",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/gallery-cuu-trai-cau",
    "desc": "Phòng trưng bày ảnh Thiên đường Cửu Trại Câu (33 ảnh)"
  },
  {
    "stt": 86,
    "time": "2026-09-16 12:26",
    "name": "Hình ảnh Cáp Nhĩ Tân",
    "cat": "Gallery Showroom",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/gallery-cap-nhi-tan",
    "desc": "Phòng trưng bày ảnh Thành phố băng Cáp Nhĩ Tân (28 ảnh)"
  },
  {
    "stt": 87,
    "time": "2026-09-16 14:02",
    "name": "Hình ảnh Chiang Mai",
    "cat": "Gallery Showroom",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/hinh-anh-chiang-mai",
    "desc": "Phòng trưng bày ảnh Chiang Mai Thái Lan (26 ảnh)"
  },
  {
    "stt": 88,
    "time": "2026-09-16 14:07",
    "name": "Hình ảnh Hồ Pangong Tso",
    "cat": "Gallery Showroom",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/hinh-anh-ho-pangong-tso",
    "desc": "Phòng trưng bày ảnh Hồ Pangong Tso nước biếc (44 ảnh)"
  },
  {
    "stt": 89,
    "time": "2026-09-16 14:19",
    "name": "Hình ảnh Lễ hội Hemis Ladakh",
    "cat": "Gallery Showroom",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/hinh-anh-le-hoi-hemis",
    "desc": "Phòng trưng bày ảnh Lễ hội Hemis Ladakh (22 ảnh)"
  },
  {
    "stt": 90,
    "time": "2026-09-16 14:37",
    "name": "Hình ảnh Iceland",
    "cat": "Gallery Showroom",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/hinh-anh-iceland",
    "desc": "Phòng trưng bày ảnh Băng đảo Iceland huyền ảo (43 ảnh)"
  },
  {
    "stt": 91,
    "time": "2026-09-16 14:43",
    "name": "Hình ảnh Ấn Độ",
    "cat": "Gallery Showroom",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/gallery-an-do",
    "desc": "Phòng trưng bày ảnh Ấn Độ đa sắc màu (49 ảnh)"
  },
  {
    "stt": 92,
    "time": "2026-09-16 14:49",
    "name": "Hình ảnh Annapurna Nepal",
    "cat": "Gallery Showroom",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/gallery-annapurna-nepal",
    "desc": "Phòng trưng bày ảnh Trekking Annapurna Nepal (10 ảnh)"
  },
  {
    "stt": 93,
    "time": "2026-09-16 19:33",
    "name": "Tour Tây An – Lạc Dương – Khai Phong 7N6Đ",
    "cat": "Tour",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-tay-an-lac-duong-7n6d",
    "desc": "Chuyển đổi từ Elementor cũ sang Native Astro 100%, chuẩn Benchmark Lệ Giang, đồng bộ bảng Lịch khởi hành ERP"
  },
  {
    "stt": 94,
    "time": "2026-09-17 14:47",
    "name": "Tây Hồ (Hàng Châu) – Cẩm nang du lịch và thông tin di sản",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/tay-ho",
    "desc": "Xây dựng bài viết Editorial Tây Hồ theo chuẩn SOP 3-6-3 grid, ảnh WebP CDN, nghiên cứu 10 cảnh đẹp Tây Hồ Thập Cảnh, quy định đặt vé chùa Linh Ẩn và bảng thông số nhanh."
  },
  {
    "stt": 95,
    "time": "2026-09-18 10:31",
    "name": "Kinh nghiệm du lịch Ninh Ba: Đi đâu, ăn gì, chơi gì từ A-Z",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/du-lich-ninh-ba",
    "desc": "Cẩm nang Ninh Ba toàn tập: Bảo tàng Ninh Ba kiến trúc Vương Thụ, cổ tự Thiên Đồng, Bảo Quốc, chính sách visa quá cảnh 240h, tàu đắm Bạch Giao I và dự toán chi phí."
  },
  {
    "stt": 96,
    "time": "2026-09-18 18:19",
    "name": "Top 15 đặc sản Trung Quốc làm quà nổi tiếng, đáng mua nhất",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/dac-san-trung-quoc",
    "desc": "Cẩm nang 18 thức quà tinh hoa ẩm thực Trung Hoa: trà Long Tỉnh, lụa Tô Châu, rượu Mao Đài, thịt sấy Kim Hoa, tối ưu Human Writing và 17 internal link topic cluster."
  },
  {
    "stt": 97,
    "time": "2026-09-21 15:09",
    "name": "Hình ảnh Đạo Thành Á Đinh",
    "cat": "Gallery Showroom",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/hinh-anh-dao-thanh-a-dinh",
    "desc": "Bổ sung 54 ảnh chụp thực địa mới nâng tổng số lên 75 ảnh 16:9 chất lượng cao, tối ưu Lightbox WCAG AAA, cấu trúc Masonry Grid và sitemap media."
  },
  {
    "stt": 98,
    "time": "2026-09-21 16:30",
    "name": "Du lịch Nước Nga: Cẩm nang & Danh sách Tour Nga cao cấp",
    "cat": "Page (Doanh nghiệp & Dịch vụ)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/country/nga",
    "desc": "Chuyển đổi trang Quốc gia Nga sang Native Astro SSR chuẩn SEO, tích hợp hero banner, cụm tour Murmansk săn cực quang và cẩm nang điểm đến."
  },
  {
    "stt": 99,
    "time": "2026-09-21 21:44",
    "name": "Đi Á Đinh bằng cách nào tốt? Bay sân bay Đạo Thành hay đường bộ từ Thành Đô",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/di-a-dinh-bang-cach-nao-tot",
    "desc": "Cẩm nang lộ trình di chuyển Á Đinh chi tiết: so sánh bay thẳng Sân bay Yading (4.411m) vs đi xe bộ thích nghi độ cao, kho 32 ảnh thực tế FIT TOUR, template chuẩn Vạn Lý Trường Thành."
  },
  {
    "stt": 100,
    "time": "2026-09-22 06:46",
    "name": "Checklist du lịch Đạo Thành Á Đinh dành cho du khách từ A–Z",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/checklist-du-lich-dao-thanh-a-dinh",
    "desc": "Checklist 22 vật dụng sống còn khi trekking độ cao 4.700m: bình oxy cá nhân, thuốc chống sốc AMS, giày leo núi chống nước, trang phục layer giữ nhiệt, SIM Tây Tạng."
  },
  {
    "stt": 101,
    "time": "2026-09-22 08:09",
    "name": "Đạo Thành Á Đinh mùa nào đẹp nhất? So sánh cảnh sắc 4 mùa",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/dao-thanh-a-dinh-mua-nao-dep",
    "desc": "Phân tích thời tiết và cảnh sắc 4 mùa Á Đinh, cửa sổ vàng lá đỏ mùa thu tháng 10, đồng cỏ đỏ Sangdui, hồ tuyết đóng băng mùa đông và bảng khí hậu từng tháng."
  },
  {
    "stt": 102,
    "time": "2026-09-22 10:02",
    "name": "Du lịch Á Đinh có mệt không? Ai nên và không nên đi?",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/du-lich-a-dinh-co-met-khong",
    "desc": "Đánh giá thể lực thực tế khi trekking Á Đinh, phân tích y khoa về hội chứng sốc độ cao cấp tính, chiến thuật phân bổ sức bền theo dặm và quy tắc an toàn y tế đoàn."
  },
  {
    "stt": 103,
    "time": "2026-09-22 10:53",
    "name": "Hồ Ngũ Sắc Á Đinh: Trekking đến hồ thiêng ở độ cao 4.700m",
    "cat": "Post (Cẩm nang)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/ho-ngu-sac",
    "desc": "Cẩm nang chinh phục Hồ Ngũ Sắc (Five Color Lake), áp dụng 40 điểm hiệu chỉnh E-E-A-T học thuật, rải đều 32 ảnh thực tế, loại bỏ AI clichés và bảo tồn văn hóa hồ thiêng Tây Tạng."
  },
  {
    "stt": 104,
    "time": "2026-09-22 15:31",
    "name": "Tour Đạo Thành Á Đinh của FIT Tour có gì đặc biệt?",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/tour-dao-thanh-a-dinh-cua-fit-tour-co-gi-dac-biet",
    "desc": "Phân tích giá trị cốt lõi tour Á Đinh của FIT TOUR: bác sĩ theo đoàn, lộ trình thích nghi độ cao từng ngày, khách sạn 4-5 sao tại Riwa (2.900m) và trải nghiệm bản địa độc bản."
  },
  {
    "stt": 105,
    "time": "2026-09-22 21:29",
    "name": "Pháo đài Sigiriya: Thành phố cung điện trên đá và Di sản UNESCO Sri Lanka",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/phao-dai-sigiriya",
    "desc": "Khảo cứu khảo cổ học Cung điện trên mây của Vua Kasyapa thế kỷ 5, Bức tường gương (Mirror Wall), bích họa tiên nữ Sigiriya Frescoes, móng chân sư tử và kinh nghiệm leo 1.200 bậc đá."
  },
  {
    "stt": 106,
    "time": "2026-09-22 21:29",
    "name": "Anuradhapura: Thành cổ thiêng liêng và cái nôi Phật giáo Sri Lanka",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/thanh-co-anuradhapura",
    "desc": "Cẩm nang di sản cây Bồ Đề Jaya Sri Maha Bodhi hơn 2.300 năm tuổi, đại bảo tháp Ruwanwelisaya, hồ chứa nước Kuttam Pokuna, phương tiện xe đạp/tuk-tuk và biểu giá vé CCF 2026."
  },
  {
    "stt": 107,
    "time": "2026-09-23 13:59",
    "name": "4 Tượng Phật Gal Vihara: Đỉnh cao điêu khắc đá Sri Lanka",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/tuong-phat-gal-vihara",
    "desc": "Kiệt tác điêu khắc đá hoa cương nguyên khối thế kỷ 12 tại Cố đô Polonnaruwa, giải mã pho tượng Phật Nhập Niết Bàn dài 14m, tượng Ananda khoanh tay và nghệ thuật điêu khắc Sinhala."
  },
  {
    "stt": 108,
    "time": "2026-09-23 14:58",
    "name": "Chùa Hang Dambulla: 5 hang đá, 157 pho tượng và Di sản UNESCO Sri Lanka",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/chua-hang-dambulla",
    "desc": "Quần thể đền hang động Phật giáo lớn nhất Sri Lanka: 5 hang động linh thiêng từ thế kỷ 1 TCN, 157 pho tượng nghệ thuật, 2.100m² bích họa trần đá và quy định trang phục kính lễ nghiêm ngặt."
  },
  {
    "stt": 109,
    "time": "2026-09-24 08:37",
    "name": "Kandyan Dance Sri Lanka: Điệu nhảy truyền thống rực lửa của Cố đô Kandy",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/dieu-nhay-kandyan-dance",
    "desc": "Di sản nghệ thuật múa trống Ves Dance truyền thống của dân tộc Sinhala, điệu múa dâng lễ rước xá lợi Răng Phật Esala Perahera, trang phục bạc chạm trổ và màn múa lửa điêu luyện."
  },
  {
    "stt": 110,
    "time": "2026-09-24 11:30",
    "name": "Nuwara Eliya: Thị trấn trà và \"Tiểu Anh Quốc\" giữa lòng Sri Lanka",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/thi-tran-nuwara-eliya",
    "desc": "Xứ sở trà Ceylon cao nguyên mát lạnh ở độ cao 1.868m, khách sạn di sản kiến trúc Victoria Grand Hotel, đồn điền chè Pedro Tea Estate, bưu điện gạch đỏ 1894 và hồ Gregory."
  },
  {
    "stt": 111,
    "time": "2026-09-24 15:03",
    "name": "Cầu 9 Nhịp ở Sri Lanka: Nine Arch Bridge Ella - Kiệt tác đường sắt giữa đồi chè",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/cau-9-nhip",
    "desc": "Cây cầu vòm đá và xi măng không dùng cốt thép xây dựng thời thuộc địa Anh năm 1921, khung giờ tàu lửa chạy qua cầu hàng ngày, kinh nghiệm đi bộ dọc đường ray và các điểm chụp ảnh triệu view."
  },
  {
    "stt": 112,
    "time": "2026-09-24 18:42",
    "name": "Top 14 địa điểm du lịch Sri Lanka đẹp nhất: Di sản, đồi trà, safari và biển",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/dia-diem-du-lich-sri-lanka",
    "desc": "Tổng hợp trọn bộ 14 thắng cảnh nổi tiếng nhất đảo ngọc Sri Lanka phân chia theo 4 vùng: Tam giác văn hóa, Cao nguyên trung tâm, Vườn quốc gia hoang dã Yala và Bờ biển nhiệt đới."
  },
  {
    "stt": 113,
    "time": "2026-09-25 06:39",
    "name": "Du lịch Sri Lanka mùa nào đẹp? Thời điểm lý tưởng theo từng tháng và khu vực",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/du-lich-sri-lanka-mua-nao-dep",
    "desc": "Phân tích chi tiết quy luật 2 mùa gió Tây Nam (Yala) và Đông Bắc (Maha), bảng thời tiết từng tháng cho từng vùng miền, giúp du khách chọn đúng bãi biển ngắm cá voi và leo núi thuận lợi."
  },
  {
    "stt": 114,
    "time": "2026-09-25 11:19",
    "name": "Chi phí du lịch Sri Lanka: Đi Sri Lanka hết bao nhiêu tiền từ A-Z?",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/chi-phi-du-lich-sri-lanka",
    "desc": "Dự toán ngân sách du lịch Sri Lanka chi tiết: vé máy bay khứ hồi từ Việt Nam, chi phí thuê xe riêng có tài xế kiêm hướng dẫn, giá vé các điểm di sản CCF, ăn uống và khách sạn 3-5 sao."
  },
  {
    "stt": 115,
    "time": "2026-09-25 15:31",
    "name": "Sri Lanka có cần visa không? Hướng dẫn xin visa ETA online cho người Việt 2026",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/sri-lanka-co-can-visa-khong",
    "desc": "Hướng dẫn từng bước xin thị thực điện tử ETA Sri Lanka cho du khách Việt Nam, lệ phí 50 USD, các lỗi form thường gặp, thủ tục nhập cảnh sân bay Bandaranaike Colombo và gia hạn visa."
  },
  {
    "stt": 116,
    "time": "2026-09-27 11:07",
    "name": "Du lịch Sri Lanka có an toàn không? Những rủi ro thực tế và cách phòng tránh",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/du-lich-sri-lanka-co-an-toan",
    "desc": "Đánh giá tình hình an ninh thực tế hậu khủng hoảng kinh tế theo khuyến cáo FCDO/WHO, các mánh khóe lừa đảo tuk-tuk, an toàn cho du khách nữ, tiêm phòng y tế và hotline cấp cứu du lịch."
  },
  {
    "stt": 117,
    "time": "2026-09-27 12:16",
    "name": "Vì sao Sri Lanka có hai mùa gió mùa? Giải thích hiện tượng Yala và Maha",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/vi-sao-sri-lanka-co-2-mua-gio",
    "desc": "Khảo cứu khí tượng học về vai trò bức tường chắn gió của Cao nguyên Trung tâm, giải thích hiện tượng nắng mưa đảo chiều giữa hai bờ biển Đông và Tây, định hình hệ sinh thái đảo quốc."
  },
  {
    "stt": 118,
    "time": "2026-09-27 16:28",
    "name": "Tại sao tàu hỏa Sri Lanka nổi tiếng? Kandy – Ella, vé, ghế ngồi và kinh nghiệm 2026",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/tai-sao-tau-hoa-sri-lanka-noi-tieng",
    "desc": "Trải nghiệm cung đường sắt đẹp nhất hành tinh Kandy - Nanu Oya - Ella, hướng dẫn phân biệt 3 hạng toa tàu, bí quyết săn vé khoang ngắm cảnh Observation Car và chụp ảnh thò đầu ngoài cửa sổ an toàn."
  },
  {
    "stt": 119,
    "time": "2026-09-27 18:56",
    "name": "Sri Lanka có gì đặc biệt? 20 điều khiến đảo quốc này khác biệt",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/sri-lanka-co-gi-dac-biet",
    "desc": "Khám phá 20 kỷ lục và nét văn hóa độc bản: mật độ di sản UNESCO cao bậc nhất châu Á, cái nôi trà Ceylon, nơi ngắm cá voi xanh lớn nhất thế giới, phong tục lắc đầu đồng ý và lòng hiếu khách phi thường."
  },
  {
    "stt": 120,
    "time": "2026-09-27 21:41",
    "name": "Đặc sản Sri Lanka: Ăn gì ở Sri Lanka? 28 món ngon nên thử",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/an-gi-sri-lanka",
    "desc": "Khám phá 28 món ăn tinh hoa ẩm thực đảo gia vị: Rice & Curry, bánh phễu trứng Egg Hoppers, bánh dẹt xào Kottu Roti, cá ngừ chua cay Ambul Thiyal, dừa nạo cay Pol Sambol và sữa chua trâu Kithul Treacle."
  },
  {
    "stt": 121,
    "time": "2026-09-28 07:34",
    "name": "Chuẩn bị gì khi du lịch Sri Lanka: Checklist thực tế cho khách Việt",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/chuan-bi-gi-khi-du-lich-sri-lanka",
    "desc": "Checklist 22 mục hành lý sống còn: quần áo dài trắng viếng chùa, tất dày đi trên đá nóng tránh bỏng chân, củ chuyển đổi phích cắm 3 chấu tròn Type D/G, SIM Dialog 4G và tiền mặt Rupee LKR."
  },
  {
    "stt": 122,
    "time": "2026-09-28 18:06",
    "name": "Cẩm nang du lịch Sri Lanka tự túc: Kinh nghiệm lên route và đi lại từ A-Z",
    "cat": "Post (Cẩm nang)",
    "act": "Nội dung mới 100%",
    "url": "https://fittour.vn/du-lich-sri-lanka-tu-tuc",
    "desc": "Cẩm nang tự túc chuyên sâu: so sánh ưu nhược điểm 4 lộ trình mẫu 7N, 8N, 10N, 12N, kinh nghiệm thuê xe có tài xế riêng Chauffeur Guide, phòng ngừa scam tuk-tuk và dự toán chi tiêu thực tế."
  },
  {
    "stt": 123,
    "time": "2026-09-28 19:56",
    "name": "Cột Mốc 250 - Hành Trình Đến Trung Quốc",
    "cat": "Page (Doanh nghiệp & Dịch vụ)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/cot-moc-250-hanh-trinh-den-trung-quoc",
    "desc": "Nâng cấp toàn diện trang Editorial Cột Mốc 250 với dynamic date trích xuất từ D1, chuẩn hóa Author Meta Bar với ảnh avatar chuyên gia và nhúng SEO Schema BlogPosting."
  },
  {
    "stt": 124,
    "time": "2026-09-29 11:22",
    "name": "Tour Hokkaido Nhật Bản 6N5Đ: Thiên đường tuyết trắng & Buffet Cua Nanda",
    "cat": "Tour (Sản phẩm)",
    "act": "Tạo mới Astro từ bài cũ",
    "url": "https://fittour.vn/tour/tour-hokkaido",
    "desc": "Xây dựng trang Native Astro chuẩn SOP Lệ Giang cho Tour Hokkaido 6N5Đ, đồng bộ bảng giá ERP 53.8 triệu, lịch trình trượt tuyết Sapporo, hồ Toya, tắm Onsen và đại tiệc cua hoàng đế."
  },
  {
    "stt": 125,
    "time": "2026-09-30 11:20",
    "name": "Tour Trung Quốc Giang Nam 5N4Đ: Thượng Hải – Hàng Châu – Ô Trấn",
    "cat": "Tour (Sản phẩm)",
    "act": "Sửa & Nâng cấp lớn",
    "url": "https://fittour.vn/tour/tour-trung-quoc-giang-nam",
    "desc": "Đại tu toàn diện lịch trình 5N4Đ theo tiêu chuẩn mới, nhúng Media ảnh thực tế cho từng ngày, Mobile CTA dock Why FIT, tối ưu typography 16px và video Facebook Reel."
  }
];
